<template>
  <div id="app" ref="app">

    <router-view >
      <div id="slide"   slot="title"  >
        <slider
          :width="300"
          :links="[
            { id: 1, text: 'Home', url: 'https://pg-app-fd8a7.firebaseapp.com/pgowner' },
            { id: 2, text: 'Owner Profile', url: 'https://pg-app-fd8a7.firebaseapp.com/ownerprofile' },
            { id: 3, text: 'Owner desk', url: 'https://pg-app-fd8a7.firebaseapp.com/ownerdesk' },
            //{ id: 4, text: 'Customer Food ', url: 'https://pg-app-fd8a7.firebaseapp.com/foodhistory' },
            { id: 5, text: 'Customer Schedules', url: 'https://pg-app-fd8a7.firebaseapp.com/ownerschedule' },
            { id: 6, text: 'Customer Registrations', url: 'https://pg-app-fd8a7.firebaseapp.com/ownerdeskdetails' },
            { id: 7, text: 'Feedback & Contact Us', url: 'https://pg-app-fd8a7.firebaseapp.com/feedback' },
            { id: 8, text: 'SignOut', url:'https://pg-app-fd8a7.firebaseapp.com/osignout'},
          ]"
          
          format="overlay"
          direction="left"
          :opacity="0.15"
        ></slider>
      </div>

       <div id="slide" slot="customer">
        <slider
          :width="300"
          :links="[
            { id: 1, text: 'Home', url: 'https://pg-app-fd8a7.firebaseapp.com/cremainder' },
            { id: 2, text: 'Profile', url: 'https://pg-app-fd8a7.firebaseapp.com/customerprofile' },
            //{ id: 3, text: 'Schedule Your Food', url: 'https://pg-app-fd8a7.firebaseapp.com/schedulefood' },
            //{ id: 4, text: 'Food History', url: 'https://pg-app-fd8a7.firebaseapp.com/cfoodhistory' },
            { id: 5, text: 'Schedules & Complaints', url: 'https://pg-app-fd8a7.firebaseapp.com/schedules' },
            { id: 6, text: 'Schedules History', url:'https://pg-app-fd8a7.firebaseapp.com/reviewschedules'},
            //{ id: 7, text: 'Payments', url: 'https://pg-app-fd8a7.firebaseapp.com/payments' },
            { id: 8, text: 'Feedback & Contact Us', url: 'https://pg-app-fd8a7.firebaseapp.com/feedback' },
            { id: 9, text: 'SignOut', url:'https://pg-app-fd8a7.firebaseapp.com/signout'},
          ]"
          format="overlay"
          direction="left"
          :opacity="0.15"
        ></slider>
      </div>

        <div id="slide" slot="admin">
        <slider
          :width="300"
          :links="[
            { id: 1, text: 'PGs', url: 'http://localhost:8080/pghome' },
            { id: 2, text: 'Careers', url: 'http://localhost:8080/careerprofiles' },
            { id: 3, text: 'PG/Hostel Registration', url: 'http://localhost:8080/pgregister' },
            { id: 4, text: 'Career Registration', url: 'http://localhost:8080/hireprofiles' },
            { id: 5, text: 'Feedback & Issues', url: 'https://pg-app-fd8a7.firebaseapp.com/reviewfeedback' },
            { id: 6, text: 'SignOut', url:'https://pg-app-fd8a7.firebaseapp.com/signout'},
          ]"
          format="overlay"
          direction="left"
          :opacity="0.15"
        ></slider>
      </div>
    </router-view>
    
  </div>
</template>

<script>
import Slider from "@jeremyhamm/vue-slider";
export default {
  name: "App",
  components: {
    slider: Slider,
  },
};
</script>

<style >
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
 
}

#slide{
  padding-top: 30px;
  padding-left: 20px;
}
</style>

